'use client';

import type { Country } from '@eliadmin/core/src/api/general/types/general-types';
import {
  AddressFields,
  BILLING_FIELDS,
} from '@eliadmin/core/src/components/dlz/auth/register/address-fields';
import { REGISTER_COPY } from '@eliadmin/core/src/components/dlz/auth/register/register-copy';
import { RegisterCard } from '@eliadmin/core/src/components/dlz/auth/register/register-card';
import {
  CheckboxField,
  TextField,
} from '@eliadmin/core/src/components/dlz/auth/register/register-fields';
import { useCompanyLookup } from '@eliadmin/core/src/components/dlz/auth/register/use-company-lookup';
import { LookupButton } from '@eliadmin/core/src/components/dlz/forms/lookup-button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/**
 * Figma „Údaje o firme“ (60260:30050): IČO with the register lookup, company name, DIČ, IČ DPH,
 * the company seat (optional) and the „iná adresa“ switch.
 */
export function CompanyCard({ countries }: { countries: Country[] }) {
  const { t } = useTranslations();
  const { status, lookup } = useCompanyLookup(countries);

  return (
    <RegisterCard title={REGISTER_COPY.company.title}>
      <div className="flex flex-col gap-4">
        <div className="grid items-start gap-4 md:grid-cols-2">
          <TextField
            name="ico"
            inputMode="numeric"
            label={t('text42')}
            required
            placeholder={t('text42')}
            hint={
              status === 'done'
                ? REGISTER_COPY.company.lookupDone
                : REGISTER_COPY.company.lookupHint
            }
            classNames={{ main: 'pr-24', after: 'pr-4' }}
            after={
              <LookupButton label={t('text871')} loading={status === 'loading'} onClick={lookup} />
            }
          />
          <TextField
            name="company"
            autoComplete="organization"
            label={t('text328')}
            required
            placeholder={t('text328')}
          />
          <TextField name="dic" label={t('text43')} required placeholder={t('text43')} />
          <TextField
            name="ic_dph"
            label={t('text44')}
            hint={REGISTER_COPY.company.vatHint}
            placeholder={t('text44')}
          />
        </div>
        <AddressFields
          fields={BILLING_FIELDS}
          countries={countries}
          autoCompletePrefix="billing "
        />
        <CheckboxField name="different_delivery_address" className="mt-2">
          {REGISTER_COPY.company.otherDelivery}
        </CheckboxField>
        <p role="status" className="sr-only">
          {status === 'done' ? REGISTER_COPY.company.lookupDone : ''}
        </p>
      </div>
    </RegisterCard>
  );
}
